import { differenceInDays, intervalToDuration, isPast } from 'date-fns';
import { useEffect, useState } from 'react';

const Countdown = ({ date }: { date?: string | number | Date }) => {
  if (!date) return null;

  const dateTill = date instanceof Date ? date : new Date(date);
  const [intervalTo, setIntervalTo] = useState(() => intervalToDuration({ start: new Date(), end: dateTill }));

  useEffect(() => {
    const timer = setInterval(() => {
      setIntervalTo(intervalToDuration({ start: new Date(), end: dateTill }));
    }, 1000);

    return () => {
      clearInterval(timer);
    };
  }, []);

  if (isPast(dateTill)) return null;

  return (
    <div className="countdown-container">
      <div className="time">
        Days
        <span className="time-number">{differenceInDays(dateTill, new Date())}</span>
      </div>
      <div className="time">
        Hours
        <span className="time-number">{intervalTo.hours}</span>
      </div>
      <div className="time">
        Minutes
        <span className="time-number">{intervalTo.minutes}</span>
      </div>
      <div className="time">
        Seconds
        <span className="time-number">{intervalTo.seconds}</span>
      </div>
    </div>
  );
};

export default Countdown;
